import router from "@/router/index";
import { RouteLocationRaw } from "vue-router";

export const scrollRedirect = (to: RouteLocationRaw, newTab: boolean = true): void =>
{
    if (newTab) window.open(router.resolve(to).href, "_blank");
    else router.push(to);
};
